import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { KpiObjectType } from '@/api/entities/kpi';

const KPI_DISTRIBUTION_URI = '/kpiDistribution';

export const getAllKpiDistributionsByType = async (
  type: KpiObjectType,
  languageCode: string,
) => {
  const params = new URLSearchParams();

  params.append('type', type);
  params.append('languageCode', languageCode);

  return requestApi({
    url: `${KPI_DISTRIBUTION_URI}/allByType?${params.toString()}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
